import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./Layout";
import Listings from "./Listings";
import Login from './Login';
import Profile from "./Profile";


function App() {
  return (
    <BrowserRouter>
      <Routes>
          <Route path = "/" element = { <Layout></Layout> }>
            <Route index element = { <Login></Login> }></Route>
            <Route path = "/profile" element = { <Profile /> }></Route>
            <Route path = "/listings" element = { <Listings /> }></Route>
          </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
